import { isPositiveNumber } from "et3-type-guards";
import React from "react";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import getCoreHistoryStore from "../../stores/core/core-history-store";
import getCorePersonalStore from "../../stores/core/core-personal-store";
import BrandPanel from "./BrandPanel";
import SignInForm from "./SignInForm";
import Welcome from "./Welcome";
import ET3PageDiv from "../../core/et3-page-div";
import ET3Div from "../../core/et3-div";
import {
  LOGIN_FULL_HEIGHT_CSS,
  LOGIN_FULL_WIDTH_CSS,
  LOGIN_NO_MINIMUM_CSS,
  LOGIN_SCREEN_HEIGHT,
  LOGIN_SCREEN_WIDTH
} from "./login-constants";

const Login = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  React.useEffect(() => {
    getCoreHistoryStore().setPageName("CORE_LOGIN", "CORE_LOGIN");
  }, []);
  const userData = getCorePersonalStore().user.get();
  const showLoginPage = !isPositiveNumber(userData.id);

  return showLoginPage ? (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={LOGIN_SCREEN_WIDTH}
      height={LOGIN_SCREEN_HEIGHT}
      fDirection={"row"}
      alignItems="stretch"
      justifyContent="flex-start"
      color={colors.all.white}
      style={{
        width: LOGIN_FULL_WIDTH_CSS,
        minWidth: LOGIN_NO_MINIMUM_CSS,
        height: LOGIN_FULL_HEIGHT_CSS,
        minHeight: LOGIN_NO_MINIMUM_CSS,
        overflow: "hidden"
      }}
      onClick={() => {}}
    >
      <BrandPanel />
      <SignInForm />
    </ET3Div>
  ) : (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Welcome />
    </ET3PageDiv>
  );
});
export default Login;
